import React from "react";
import Modal from "..";
import * as S from "./checkTransportationModal.style";
import { Button } from "../../../atoms/Buttons";

type CheckTransportationModalType = {
  onModalCloseHanlder: () => void;
};

const CheckTransportationModal = ({
  onModalCloseHanlder,
}: CheckTransportationModalType) => {
  return (
    <Modal title="사진등록 완료" titlePosition="center" size="md">
      <S.CheckTransportationModalLayout>
        <p> 사진등록 및 저장이 완료되었습니다. </p>
        <Button
          type="button"
          size="full"
          color="primary"
          label="확인"
          onClick={onModalCloseHanlder}
        />
      </S.CheckTransportationModalLayout>
    </Modal>
  );
};

export default CheckTransportationModal;
